import {
    UPDATE_ACCESS_LOG,
    APPEND_ACCESS_LOG,
    FETCH_MORE_LOGS,
    PREPEND_ACCESS_LOG
} from 'store/actions/types';

export const fetchMoreAccessLogs = data => {
    console.log('dataaaaa', data);
    return {
        type: FETCH_MORE_LOGS,
        payload: data
    };
};

export const updateAccessLog = logs => ({
    type: UPDATE_ACCESS_LOG,
    payload: logs
});

export const appendAccessLog = logs => ({
    type: APPEND_ACCESS_LOG,
    payload: logs
});

export const prependAccessLog = logs => ({
    type: PREPEND_ACCESS_LOG,
    payload: logs
});
